<template>
  <!-- 个人中心总页面 -->
  <div class="aboutUs">
    <div class="aboutUs_content">
      <div class="aboutUs_left">
        <!-- 固定展开的菜单 -->
        <div class="aboutName">
          <div v-for="(item,index) in menuList" :key="item+index">
            <h3 class="aboutUs_menu_title">{{item.title}}</h3>
            <div v-for="(i,idx) in item.children" :key="i+idx">
              <div
                @click="selectSubName(i,idx)"
                class="aboutUs_menu_subtitle"
                :class="{activeSubName: activeSubIndex == i.index}"
                v-if="!i.hidden"
              >{{i.title}}</div>
            </div>
          </div>
        </div>
        <!-- 可折叠的带有动画的菜单 -->
        <!-- <el-menu :default-active="activeSubIndex" active-text-color="#84B7F9">
          <el-submenu :index="item.index" v-for="(item,index) in menuList" :key="item+index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span> {{ item.title }} </span>
            </template>
            <el-menu-item-group v-for="(i,idx) in item.children.filter(item => !item.hidden)" :key="i+idx">
              <el-menu-item :index="i.index" @click="selectSubName(i,idx)"> {{ i.title }} </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu> -->
      </div>
      <div class="aboutUs_right">
        <!-- 我的资产 -->
        <myAssets :info="selectMenu" v-if="activeSubIndex == '1-1'" @gotoPage="gotoPage"></myAssets>
        <!-- 个人资料 -->
        <personalData :info="selectMenu" v-if="activeSubIndex == '1-2'" @gotoPage="gotoPage"></personalData>
        <!-- 身份认证 -->
        <identityAuth v-if="activeSubIndex == '1-3'" @gotoPage="gotoPage"></identityAuth>
        <!-- 邀请好友 -->
        <inviteFriends :info="selectMenu" v-if="activeSubIndex == '1-4'"></inviteFriends>
        <!-- 积分商城 -->
        <intergraMall :info="selectMenu" v-if="activeSubIndex == '1-5'"></intergraMall>
        <!-- 我的订单 -->
        <myGoods :info="selectMenu" ref="orderList" v-if="activeSubIndex == '2-1'"></myGoods>
        <!-- 商城订单 -->
        <mallOrder :info="selectMenu" ref="mallOrder" v-if="activeSubIndex == '2-6'"></mallOrder>
        <!-- 优惠券 -->
        <coupon :info="selectMenu" v-if="activeSubIndex == '2-2'"></coupon>
        <!-- 赠送金 -->
        <voucher :info="selectMenu" v-if="activeSubIndex == '2-3'"></voucher>
        <!-- 订单操作---个人 -->
        <userOrderOperate ref="userOrderOperate" v-if="activeSubIndex == '2-4'"></userOrderOperate>
        <!-- 草稿箱 -->
        <drafts v-if="activeSubIndex == '2-5'"></drafts>
        <!-- 开票信息 -->
        <invoiceInfo v-if="activeSubIndex == '3-1'"></invoiceInfo>
        <!-- 我的发票 -->
        <myInvoice v-if="activeSubIndex == '3-2'" ></myInvoice>
        <!-- 抬头管理 -->
        <invoiceHeaders v-if="activeSubIndex == '3-3'" ></invoiceHeaders>
        <!-- 加入团队 -->
        <joinTeam :info="selectMenu" v-if="activeSubIndex == '4-1'" @gotoPage="gotoPage"></joinTeam>
        <!-- 创建团队 -->
        <createTeam :info="selectMenu" v-if="activeSubIndex == '4-2'" @selectSubName="selectSubName"></createTeam>
        <!-- 团队管理 -->
        <myTeam :info="selectMenu" v-if="activeSubIndex == '4-3'" @selectSubName="selectSubName"></myTeam>
        <!-- 团队订单 -->
        <teamGoods :info="selectMenu" v-if="activeSubIndex == '4-4'"></teamGoods>
        <!-- 团队商城订单 -->
        <teamMallOrder v-if="activeSubIndex == '4-8'"></teamMallOrder>
        <!-- 团队订单操作 -->
        <teamOrderOperate ref="teamOrderOperate" v-if="activeSubIndex == '4-5'"></teamOrderOperate>
        <!-- 财务中心 -->
        <financialCenter v-if="activeSubIndex == '4-6'" @gotoPage="gotoPage"></financialCenter>
        <!-- 团队发票 -->
        <teamInvoice v-if="activeSubIndex == '4-7'"></teamInvoice>
        <!-- 我的文件 -->
        <myFile v-if="activeSubIndex == '5-1'"></myFile>
        <!-- 团队文件 -->
        <teamFile v-if="activeSubIndex == '5-2'"></teamFile>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import myAssets from "./myAssets";
import personalData from "./personalData";
import joinTeam from "./joinTeam";
import createTeam from "./createTeam";
import myTeam from "./myTeam";
import myGoods from "./myGoods";  
import teamGoods from "./teamGoods";
import teamMallOrder from "./teamMallOrder.vue";
import teamOrderOperate from "./teamOrderOperate.vue";
import inviteFriends from "./inviteFriends";
import coupon from "./coupon";
import voucher from "./voucher";
import invoiceInfo from "./invoiceInfo";
import myInvoice from "./myInvoice";
import teamFile from "./teamFile";
import myFile from "./myFile";
import intergraMall from "./intergraMall"
import invoiceHeaders from "./invoiceHeaders"
import financialCenter from "./financialCenter"
import drafts from "./drafts"
import userOrderOperate from "./userOrderOperate.vue";
import IdentityAuth from './identityAuth.vue';
import teamInvoice from "./teamInvoice.vue";
import mallOrder from "./mallOrder.vue";

export default {
  components: {
    personalData,
    joinTeam,
    createTeam,
    myTeam,
    myGoods,
    inviteFriends,
    coupon,
    voucher,
    myAssets,
    teamGoods,
    teamMallOrder,
    teamOrderOperate,
    invoiceInfo,
    myInvoice,
    teamFile,
    myFile,
    intergraMall,
    invoiceHeaders,
    financialCenter,
    drafts,
    userOrderOperate,
    IdentityAuth,
    teamInvoice,
    mallOrder,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    menuList() {
      return [
        {
          title: "账号管理",
          icon: 'el-icon-house',
          index: '1',
          children: [
            { title: "我的资产", index: "1-1" },
            { title: "个人资料", index: "1-2" },
            { title: "身份认证", index: "1-3", hidden: true},
            { title: "邀请好友", index: "1-4" },
            { title: "积分商城", index: "1-5" },
            { title: "合作入驻", index: "1-6" },
            { title: "专利服务", index: "1-7" },
          ]
        },
        {
          title: "订单管理",
          icon: 'el-icon-notebook-2',
          index: '2',
          children: [
            { title: "我的订单", index: "2-1" },
            { title: "商城订单", index: "2-6" },
            { title: "订单操作", index: "2-4" },
            { title: "草稿箱", index: "2-5" },
            { title: "优惠券", index: "2-2" },
            // { title: "赠送金", index: "2-3" },
          ]
        },
        {
          title: "发票管理",
          icon: 'el-icon-tickets',
          index: '3',
          children: [
            { title: "开票信息", index: "3-1" },
            { title: "我的发票", index: "3-2" },
            { title: "抬头管理", index: "3-3" },
            ]
        },
        {
          title: "我的团队",
          icon: 'el-icon-user',
          index: '4',
          children: [
            //加入团队后将标识符存入store,根据标识符判断显示哪些
            {
              title: "加入团队",
              index: "4-1",
              hidden: this.userInfo.teamId && this.userInfo.teamId != ""
            },
            {
              title: "创建团队",
              index: "4-2",
              hidden: this.userInfo.teamId && this.userInfo.teamId != ""
            },
            {
              title: "团队管理",
              index: "4-3",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == ""
            },
            {
              title: "团队订单",
              index: "4-4",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == "" || this.userInfo.characterRole == 3
            },
            {
              title: "商城订单",
              index: "4-8",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == "" || this.userInfo.characterRole == 3
            },
            {
              title: "订单操作",
              index: "4-5",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == "" || this.userInfo.characterRole == 3
            },
            {
              title: "财务中心",
              index: "4-6",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == "" || this.userInfo.characterRole == 3
            },
            {
              title: "团队发票",
              index: "4-7",
              hidden: !this.userInfo.teamId || this.userInfo.teamId == "" || this.userInfo.characterRole == 3
            },
          ]
        },
        {
          title: "云文件",
          icon: 'el-icon-folder-opened',
          index: '5',
          children: [
            { title: "我的文件", index: "5-1" },
            { title: "团队文件", index: "5-2",hidden: this.userInfo.commanderFlag != 1 }
          ]
        }
      ];
    }
  },
  watch: {
    $route: {
      deep: true, // 深度监听
      handler(val) {
        this.activeSubIndex = val.query.tabIndex;
        this.selectMenu.title = val.query.tabName;
      }
    }
  },
  created() {
    this.activeSubIndex = this.$route.query.tabIndex ? this.$route.query.tabIndex : "1-1";
    this.selectMenu.title = this.$route.query.tabName;
    this.selectName = this.$route.query.tabName;
  },
  data() {
    return {
      selectName: "个人资料",
      activeSubIndex: "1-1",
      selectMenu: {},
    };
  },
  methods: {
    selectSubName(item, index) {
      if (item.index == "1-6") {
        this.$router.push('/cooperativeSettlement')
      } else if(item.index == "1-7") {
        this.$router.push('/patentServices')
      } else if(item.index == "4-2") {
        if (this.$store.getters.userInfo.realNameStatus == 1) {
          this.linkName(item, index);
        } else {
          this.$confirm("创建团队前需先完成实名认证，是否前往实名认证？", "提示", {
            confirmButtonText: "去实名",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.linkName({index: '1-2',title: '个人资料'});
            })
            .catch(() => {});
        }
      } else {
        this.linkName(item, index);
      }
    },
    linkName(item,index) {
      if(item.title === '我的订单' && item.title === this.$route.query.tabName && this.$refs.orderList){
        this.$refs.orderList.init()
      }
      if(item.title === '商城订单' && item.title === this.$route.query.tabName && this.$refs.mallOrder){
        this.$refs.mallOrder.init()
      }
      this.$router.push({ query: { tabIndex: item.index, tabName: item.title } })
        .catch(() => {});
      this.activeSubIndex = item.index;
      // this.selectMenu = item;
      document.documentElement.scrollTop = 0;
    },
    //页面跳转
    gotoPage(activeSubIndex, DomRef, operateIndex) {
      this.activeSubIndex = activeSubIndex
      if(DomRef) {
        //此处写没有operateIndex时的情况，如调用某个组件的某个函数
        if(operateIndex >= 0) {
          this.$nextTick(() => {
            this.$refs[DomRef].changeOperate(operateIndex)
          })
        }
      }
    }
  }
};
</script>
<style scoped>
.aboutUs {
  width: 80%;
  margin: 20px auto;
  max-width: 1920px;
}
.aboutUs_left {
  width: 220px;
  background: #fff;
  /* height: calc(100vh - 110px);
  overflow: hidden;
  overflow-y: scroll; */
}
.aboutUs_content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.aboutUs_right {
  /* margin-left: 40px; */
  width: calc(100% - 240px);
}
.aboutUs_menu_title {
  padding-left: 30%;
  margin: 20px 0;
  /* margin: 20px; */
  /* width: 50%; */
}
.aboutUs_menu_subtitle {
  width: 70%;
  padding-left: 28%;
  line-height: 45px;
  color: #666666;
  font-size: 14px;
  cursor: pointer;
  border-left: 5px solid transparent;
}
.activeSubName {
  background: #fbfbfb;
  color: #84B7F9;
  border-left: 5px solid #84B7F9;
}
</style>
